import React from "react";

const ItemTable = ({ items, variant = "valid", getTotalQuantity }) => {
    const isValid = variant === "valid";
    const headerBg = isValid ? "bg-gray-200 text-gray-700" : "bg-red-100 text-red-600";
    const qtyClass = isValid ? "text-[var(--color-2)]" : "text-red-500";

    if (!items?.length) {
        return (
            <p className={`text-center text-[13px] py-4 ${isValid ? "text-gray-400" : "text-red-300"}`}>
                No {isValid ? "valid" : "invalid"} scans this month
            </p>
        );
    }

    return (
        <div className="space-y-2">
            <div className={`flex justify-between text-sm ${headerBg} p-2 rounded text-[14px] px-[20px] font-bold`}>
                <span className={`${isValid ? "w-1/2" : "w-[30%]"} th-center`}>Product UPC</span>
                {!isValid && <span className="w-[40%] th-text">Description</span>}
                            <span className={`${isValid ? "w-1/2" : "w-[15%]"} th-center`}>Quantity</span>
            </div>
            {items.map((item) => (
                <div
                    key={item.upc}
                    className="flex justify-between text-sm p-[0px_20px] border-[1px] border-gray-200"
                >
                    <span className={`font-mono td-num ${isValid ? "w-1/2 border-r-[1px] border-gray-200" : "w-[30%] border-r-[1px] border-gray-200"} py-[8px] ${!isValid && "text-red-500"}`}>
                        {item.upc}
                    </span>
                    {!isValid && (
                        <span className="w-[40%] border-r-[1px] border-gray-200 py-[8px] px-2 td-text text-gray-600 truncate">
                            {item.description || "—"}
                        </span>
                    )}
                    <span className={`text-[16px] td-center ${isValid ? "w-1/2" : "w-[15%]"} py-[8px] font-bold ${qtyClass}`}>
                        {item.quantity}
                    </span>
                </div>
            ))}
            <div className="text-right mt-[0.5vmax] text-[1vmax] font-bold">
                Total Quantity :{" "}
                <span className={isValid ? "text-blue-500" : "text-red-500"}>
                    {getTotalQuantity(items)}
                </span>
            </div>
        </div>
    );
};

const SectionHeader = ({ variant, group, isSelected, onToggle, hasData }) => {
    const isValid = variant === "valid";
    const label = isValid ? "Valid Scans" : "Invalid Scans";
    const icon = isValid ? "fa-solid fa-check-circle" : "fa-regular fa-xmark-circle";
    const colorClass = isValid ? "text-green-700" : "text-red-500";
    const accentClass = isValid ? "accent-green-600" : "accent-red-600";

    return (
        <label className={`mb-3 font-bold ${colorClass} flex items-center gap-2 ${hasData ? "cursor-pointer" : "cursor-not-allowed opacity-60"}`}>
            <input
                type="checkbox"
                className={`w-5 h-5 shrink-0 ${accentClass}`}
                checked={isSelected}
                disabled={!hasData}
                onChange={() => hasData && onToggle(group, variant)}
            />
            <i className={icon} />
            <span>{label}</span>
        </label>
    );
};

const SlipsTable = ({
    monthlyGroups,
    isSectionSelected,
    toggleSection,
    getTotalQuantity,
}) => {
    const hasSectionData = (group, variant) =>
        variant === "valid" ? group.validItems?.length > 0 : group.invalidItems?.length > 0;

    return (
        <div className="px-[1.5vmax] pr-[2.5vmax] mx-auto">
            {monthlyGroups?.length > 0 ? monthlyGroups.map((group) => (
                <div
                    key={group.periodKey}
                    className="border rounded-2xl p-4 mb-4 bg-white shadow-1"
                >
                    <div className="flex items-center justify-between mb-4 pb-2 border-b border-gray-100">
                        <div>
                            <h3 className="text-[16px] font-bold text-slate-800">{group.periodLabel}</h3>
                            <p className="text-[12px] text-gray-500">
                                {group.sessionCount} scan session{group.sessionCount !== 1 ? "s" : ""}
                            </p>
                        </div>
                        <div className="flex items-center gap-3">
                            {group.status === 1
                                ? <div className="bg-green-700 text-[12px] text-white px-2 py-0.5 rounded">Exported</div>
                                : <div className="bg-red-700 text-[12px] text-white px-2 py-0.5 rounded">Not Exported</div>
                            }
                        </div>
                    </div>

                    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                        <div>
                            <SectionHeader
                                variant="valid"
                                group={group}
                                isSelected={isSectionSelected(group, "valid")}
                                onToggle={toggleSection}
                                hasData={hasSectionData(group, "valid")}
                            />
                            <ItemTable
                                items={group.validItems}
                                variant="valid"
                                getTotalQuantity={getTotalQuantity}
                            />
                        </div>
                        <div>
                            <SectionHeader
                                variant="invalid"
                                group={group}
                                isSelected={isSectionSelected(group, "invalid")}
                                onToggle={toggleSection}
                                hasData={hasSectionData(group, "invalid")}
                            />
                            <ItemTable
                                items={group.invalidItems}
                                variant="invalid"
                                getTotalQuantity={getTotalQuantity}
                            />
                        </div>
                    </div>
                </div>
            )) : (
                <p className="text-center text-gray-500 mt-10">No inventory slips found.</p>
            )}
        </div>
    );
};

export default SlipsTable;
